export interface ICAMSKey {
    featureType?: FeatureType,
    code?: string;
    uid?: number;
    nodeId?: string;
    lat?: any;
    lon?: any;
    wkt?: string;
    zoom?: number;
    metadata?: ICAMSFeatureMetadata;
    parentFeatureType?: FeatureType;
    parentCode?: string;
}

export interface ICAMSFeatureMetadata {
    featureLength?: number;
    featureArea?: number;
}

export interface IFeaturesRequest {
    maintCodes: Array<string>;
    infraCodes: Array<string>;
    routeCodes: Array<string>;
    landCodes: Array<string>;
    legalRoutes: Array<string>;
    legalFeatures: Array<string>;
    infraHistoricCodes: Array<string>;
    annotationGeomIDs: Array<string>;
    troGeomIDs: Array<string>;
    ReturnPathsOnly?: boolean;
}

export interface IMapInteractionConfig {
    zoomToSelectedFeatures?: Boolean;
    addToExistingSelection?: Boolean;
    selectableLayers?: Array<FeatureType>;
    hitTolerance?: number;
    resetAllInteractions?: Boolean;
}

export interface INode {
    text?: string;
    href?: string;
    featureType?: FeatureType;
    parentFeatureType?: FeatureType;
    parentCode?: string;
    count?: number;
    wkt?: string;
    data?: any;
    enableActionsIcon?: boolean;
    enableDetailsIcon?: boolean;
    enableTrashIcon?: boolean;
    doNotShowCheckbox?: boolean;
    tags?: Array<string>;
    nodes?: Array<INode>;
}

export interface IAPIResult {
    success?: boolean;
    message?: string;
    data?: any;
    totalCount?: number;
    error?: string;

    consultationID?: number;
    maintCode?: string;
    code?: string;
    total?: number;
    uid?: number;
    title?: string;
}

export enum MapInteractionType {
    NoInteraction,
    SelectInteraction,
    SelectSingleInteraction,
    SelectRouteInteraction,
    SelectRectangleInteraction,
    SelectMultiAndRectangleInteraction,
    DrawInteraction,
    ModifyInteraction,
    LocationInfo
}

export enum FeatureType {
    MaintParent,
    InfraParent,
    RouteParent,
    LandParent,
    PathParent,
    Maint,
    Route,
    Infra,
    Land,
    Path,
    AdminArea,
    LatLon,
    TaskParent,
    Task,
    TaskGroup,
    Activity,
    Contact, 
    LegalEvent,
    LegalConsultation,
    Annotation,
    TRO,
    RouteCondition,
    InfraCondition,
    RouteStatement,
    LandCondition,
    InfraHistoric,
    LegalFeature
}

export interface IFeatureTypeOptions {
    featureType: FeatureType,
    visible: boolean
}

export enum OrderDirection {
    ASC,
    DESC
}

export enum TextPack {
    None,
    MyTasksTextPack,
    OfficerMapTextPack,
    ReportAnIssueTextPack,
    InfraTextPack,
    LandTextPack,
    MaintTextPack,
    PathTextPack,
    RouteTextPack,
    SearchTextPack,
    SelectListTextPack,
    MenusTextPack,
    HelpTextPack,
    TaskManagementTextPack,
    SubmissionsTextPack,
    LegalTextPack,
    AnnotationsTextPack,
    ConsultationsTextPack,
    ContactsTextPack,
    NotificationsTextPack,
    TROTextPack,
    PhotosTextPack,
    OtherPagesTextPack,
    MapsTextPack,
    ActivityTextPack
}

export enum CloseFormEnum{
    SaveAndProceed, 
    DisregardAndProceed, 
    Cancel, 
}

export enum MenuType {
    none,
    rai,
    om,
    mt,
    tm,
    sub,
    ann,
    con,
    le
}



